import { JournalGLConfig } from '../utils/urlResolver';
import axios from '.';

export const getGLConfigEvents = (params) => {
  return axios({
    method: 'GET',
    url: JournalGLConfig.eventList,
    params,
  });
};

export const getGLConfigData = (params) => {
  return axios({
    method: 'GET',
    url: JournalGLConfig.listData,
    params,
  });
};

export const updateGLConfigData = (data) => {
  return axios({
    method: 'PUT',
    url: JournalGLConfig.updateData,
    data,
  });
};

export const getCancelReasonList = (params) => {
  return axios({
    method: 'GET',
    url: JournalGLConfig.cancelReasonList,
    params,
  });
};

export const getGLExceptionData = (params) => {
  return axios({
    method: 'GET',
    url: JournalGLConfig.glExceptionData,
    params,
  });
};

export const getGLExceptionDataCount = (params) => {
  return axios({
    method: 'GET',
    url: JournalGLConfig.glExceptionDataCount,
    params,
  });
};

export const GLExceptionRegenerate = (data) => {
  return axios({
    method: 'POST',
    url: `${JournalGLConfig.glExceptionRegenerate}/${data.id}`,
    data,
  });
};
